<template>
  <div>
    <el-menu :default-active="$route.path" background-color="#f4fbfe" :router='isTrue' unique-opened @select="selectMenu">
      <nav-bar-item v-for="(item, n) in navList" :item="item" :navIndex="String(n)" :key="n">
        {{n}}
      </nav-bar-item>
    </el-menu>
  </div>
</template>
<script>
import NavBarItem from './NavBarItem'
export default {
  components: { NavBarItem },
  inject: ['reload'],
  data () {
    return {
      isTrue: true
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getMenuList()
    },
    // 请求菜单
    getMenuList () {
      this.$axios
        .post(this.$api.menu)
        .then(response => {
          this.setCookie('staffName', response.data.staffName, 7)
          // 存菜单
          this.$store.commit('setMenuItems', response.data.menuList)
          // 存登录名
          this.$store.commit('setStaffName', response.data.staffName)
          // 存userAcount
          this.$store.commit('userAcount', response.data.userAccount)
          // 存权限
          this.$store.commit('setRoleList', response.data.staffFunctionPermit)
        })
        .catch(error => {
          console.log(error)
        })
    },
    selectMenu (index, indexPath) {
      // 点击已选中菜单刷新
      this.reload()
    }
  },
  computed: {
    navList () {
      return this.$store.state.menuItems
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/NavBar.vue